/* Header: rearrange into the reference layout, merge it into the hero, and
   swap Dawn's cart glyph for a plain shopping bag.
     [menu search]   logo   [wishlist cart]
   Dawn renders search inside .header__icons on the right and CSS cannot move a
   node between parents, so it is relocated here. Everything is guarded so a
   markup change in a future Dawn version degrades to the stock header. */
(function () {
  'use strict';

  var BAG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round" class="icon yb-bag" aria-hidden="true" focusable="false">' +
    '<path d="M3.5 7.5h17l-1 12.2a1.3 1.3 0 0 1-1.3 1.3H5.8a1.3 1.3 0 0 1-1.3-1.3L3.5 7.5Z"/>' +
    '<path d="M8.6 10V6.4a3.4 3.4 0 0 1 6.8 0V10"/></svg>';

  function init() {
    var header = document.querySelector('.header');
    if (!header || header.dataset.ybDone) return;
    header.dataset.ybDone = '1';

    var drawer = header.querySelector('header-drawer');
    var search = header.querySelector('.header__search, details-modal.header__search');
    var icons = header.querySelector('.header__icons');

    var left = document.createElement('div');
    left.className = 'yb-hleft';
    if (drawer) left.appendChild(drawer);
    if (search) left.appendChild(search);
    if (left.children.length) header.insertBefore(left, header.firstChild);

    /* ---- Merge the header into the hero photo ----
       The hero is position:sticky so the wall can scroll up over it. That means
       its getBoundingClientRect() stays pinned at the top no matter how far you
       scroll, so a rect-based test never fires and the header stays white over
       the products. Measure scroll distance against the hero's own height. */
    var hero = document.querySelector('.yb-hero-section, .yb-hero');
    if (hero) {
      document.body.classList.add('yb-overlay');
      var mark = function () {
        var headH = header.offsetHeight || 60;
        var trigger = Math.max(0, hero.offsetHeight - headH);
        var y = window.scrollY || window.pageYOffset || 0;
        document.body.classList.toggle('yb-scrolled', y >= trigger);
      };
      mark();
      window.addEventListener('scroll', mark, { passive: true });
      window.addEventListener('resize', mark);
      window.addEventListener('load', mark);
    }

    if (!icons) return;

    /* ---- Swap the cart glyph, keeping Dawn's count bubble intact ---- */
    var cartLink = icons.querySelector('#cart-icon-bubble');
    if (cartLink) {
      var oldSvg = cartLink.querySelector('svg');
      if (oldSvg) {
        var holder = document.createElement('span');
        holder.innerHTML = BAG;
        var newSvg = holder.firstChild;
        if (oldSvg.getAttribute('class')) {
          newSvg.setAttribute('class', oldSvg.getAttribute('class') + ' yb-bag');
        }
        oldSvg.replaceWith(newSvg);
      }
    }

    /* ---- Wishlist ---- */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'yb-wish-btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Saved items');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="m12 3.6 2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L3.5 9.8l5.9-.9z"/></svg>' +
      '<span class="yb-wish-count" hidden>0</span>';

    var cartWrap = cartLink ? cartLink.closest('a, .header__icon') || cartLink : null;
    if (cartWrap && cartWrap.parentNode === icons) icons.insertBefore(btn, cartWrap);
    else icons.appendChild(btn);

    var panel = document.createElement('div');
    panel.className = 'yb-wish-panel';
    panel.hidden = true;
    header.appendChild(panel);

    function read() {
      try {
        var v = JSON.parse(localStorage.getItem('yb:wishlist') || '[]');
        return Array.isArray(v) ? v : [];
      } catch (e) { return []; }
    }
    function pretty(h) {
      return h.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
    function paint() {
      var items = read();
      var count = btn.querySelector('.yb-wish-count');
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
      if (!items.length) {
        panel.innerHTML = '<h3>Saved</h3><p>Nothing saved yet. Tap the star on any product.</p>';
        return;
      }
      panel.innerHTML = '<h3>Saved (' + items.length + ')</h3><ul>' +
        items.map(function (h) {
          return '<li><a href="/products/' + encodeURIComponent(h) + '">' + pretty(h) + '</a></li>';
        }).join('') + '</ul>';
    }

    paint();

    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      if (!open) paint();
      btn.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (btn.contains(e.target) || panel.contains(e.target)) return;
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        panel.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
    document.addEventListener('yb:wish', paint);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
